import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-6 bg-white rounded-lg shadow-md" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 p-3 bg-blue-100 text-blue-700 rounded-md"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = {
  key: 0,
  class: "p-4 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_10 = { class: "whitespace-pre-wrap" }
const _hoisted_11 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-4 border-t border-red-200 pt-4"
}
const _hoisted_13 = {
  key: 1,
  class: "mt-4 whitespace-pre-wrap bg-red-50 p-2 rounded"
}
const _hoisted_14 = { class: "mt-8 border-t border-gray-200 pt-6" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_27 = {
  key: 0,
  class: "p-4 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_28 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_31 = {
  key: 0,
  class: "mt-4 border-t border-red-200 pt-4"
}
const _hoisted_32 = { class: "list-decimal pl-5 mb-4" }
const _hoisted_33 = { class: "mt-8 border-t border-gray-200 pt-6" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]
const _hoisted_39 = ["value"]
const _hoisted_40 = ["value"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_45 = {
  key: 0,
  class: "p-4 bg-gray-100 rounded-md"
}
const _hoisted_46 = { class: "font-bold mb-2" }
const _hoisted_47 = { class: "divide-y divide-gray-200" }
const _hoisted_48 = { class: "flex justify-between items-center" }
const _hoisted_49 = { class: "font-medium" }
const _hoisted_50 = { class: "text-sm text-gray-500" }
const _hoisted_51 = { class: "flex space-x-2" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "p-4 bg-yellow-100 text-yellow-700 rounded-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Supabase Storage Test", -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Error: " + _toDisplayString(_ctx.error.message), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-xl font-bold mb-2" }, "Storage Connection Test", -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testStorageConnection && _ctx.testStorageConnection(...args))),
        class: "px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors",
        disabled: _ctx.loading
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Testing..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "Test Storage Connection"))
      ], 8, _hoisted_5),
      (_ctx.storageTestResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.storageTestResult.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "font-bold" }, "Storage Connection Successful!", -1)),
                  _createElementVNode("pre", _hoisted_10, _toDisplayString(JSON.stringify(_ctx.storageTestResult.data, null, 2)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "font-bold" }, "Storage Connection Error", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.storageTestResult.message), 1),
                  (_ctx.storageTestResult.error && _ctx.storageTestResult.error.statusCode === 404)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[7] || (_cache[7] = [
                        _createElementVNode("h5", { class: "font-bold" }, "Missing Bucket Error", -1),
                        _createElementVNode("p", { class: "mb-2" }, "The required storage buckets have not been created yet. Please create the following buckets in your Supabase instance:", -1),
                        _createElementVNode("ul", { class: "list-disc pl-5 mb-4" }, [
                          _createElementVNode("li", null, "templates"),
                          _createElementVNode("li", null, "documents"),
                          _createElementVNode("li", null, "calendars"),
                          _createElementVNode("li", null, "avatars"),
                          _createElementVNode("li", null, "reports"),
                          _createElementVNode("li", null, "forecasts")
                        ], -1),
                        _createElementVNode("p", null, "You can create these buckets in the Supabase dashboard under Storage.", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.storageTestResult.error)
                    ? (_openBlock(), _createElementBlock("pre", _hoisted_13, _toDisplayString(JSON.stringify(_ctx.storageTestResult.error, null, 2)), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "File Upload Test", -1)),
      _createElementVNode("div", _hoisted_15, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "bucket-select",
          class: "block text-sm font-medium mb-1"
        }, "Select Bucket", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "bucket-select",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBucket) = $event)),
          class: "w-full px-3 py-2 border border-gray-300 rounded-md"
        }, [
          _createElementVNode("option", {
            value: _ctx.StorageBucket.TEMPLATES
          }, "Templates", 8, _hoisted_16),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.DOCUMENTS
          }, "Documents", 8, _hoisted_17),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.CALENDARS
          }, "Calendars", 8, _hoisted_18),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.AVATARS
          }, "Avatars", 8, _hoisted_19),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.REPORTS
          }, "Reports", 8, _hoisted_20),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.FORECASTS
          }, "Forecasts", 8, _hoisted_21)
        ], 512), [
          [_vModelSelect, _ctx.selectedBucket]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "file-upload",
          class: "block text-sm font-medium mb-1"
        }, "Select File", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "file-upload",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          class: "w-full px-3 py-2 border border-gray-300 rounded-md"
        }, null, 32)
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
        class: "px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors",
        disabled: _ctx.loading || !_ctx.selectedFile
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Uploading..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_25, "Upload File"))
      ], 8, _hoisted_23),
      (_ctx.uploadResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            (_ctx.uploadResult.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "font-bold" }, "File Upload Successful!", -1)),
                  _createElementVNode("p", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Original filename:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.uploadResult.originalName), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Sanitized path:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.uploadResult.path), 1)
                  ]),
                  (_ctx.uploadResult.publicUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mb-2" }, "Public URL:", -1)),
                        _createElementVNode("a", {
                          href: _ctx.uploadResult.publicUrl,
                          target: "_blank",
                          class: "text-blue-600 underline"
                        }, _toDisplayString(_ctx.uploadResult.publicUrl), 9, _hoisted_29)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "font-bold" }, "File Upload Error", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.uploadResult.message), 1),
                  (_ctx.uploadResult.isBucketNotFound)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "font-bold" }, "Bucket Not Found", -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mb-2" }, "The storage bucket doesn't exist in your Supabase project. Please create it:", -1)),
                        _createElementVNode("ol", _hoisted_32, [
                          _cache[17] || (_cache[17] = _createElementVNode("li", null, "Go to your Supabase project dashboard", -1)),
                          _cache[18] || (_cache[18] = _createElementVNode("li", null, "Navigate to the \"Storage\" section", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("li", null, "Click \"Create a new bucket\"", -1)),
                          _createElementVNode("li", null, [
                            _cache[16] || (_cache[16] = _createTextVNode("Create a bucket named ")),
                            _createElementVNode("code", null, _toDisplayString(_ctx.selectedBucket), 1)
                          ]),
                          _cache[20] || (_cache[20] = _createElementVNode("li", null, "Set the appropriate permissions for the bucket", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_33, [
      _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "File List", -1)),
      _createElementVNode("div", _hoisted_34, [
        _cache[25] || (_cache[25] = _createElementVNode("label", {
          for: "list-bucket-select",
          class: "block text-sm font-medium mb-1"
        }, "Select Bucket", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "list-bucket-select",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listBucket) = $event)),
          class: "w-full px-3 py-2 border border-gray-300 rounded-md"
        }, [
          _createElementVNode("option", {
            value: _ctx.StorageBucket.TEMPLATES
          }, "Templates", 8, _hoisted_35),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.DOCUMENTS
          }, "Documents", 8, _hoisted_36),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.CALENDARS
          }, "Calendars", 8, _hoisted_37),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.AVATARS
          }, "Avatars", 8, _hoisted_38),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.REPORTS
          }, "Reports", 8, _hoisted_39),
          _createElementVNode("option", {
            value: _ctx.StorageBucket.FORECASTS
          }, "Forecasts", 8, _hoisted_40)
        ], 512), [
          [_vModelSelect, _ctx.listBucket]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.listFiles && _ctx.listFiles(...args))),
        class: "px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors",
        disabled: _ctx.loading
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Loading..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_43, "List Files"))
      ], 8, _hoisted_41),
      (_ctx.fileList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            (_ctx.fileList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("h4", _hoisted_46, "Files in " + _toDisplayString(_ctx.listBucket) + " bucket:", 1),
                  _createElementVNode("ul", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: file.name,
                        class: "py-2"
                      }, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_49, _toDisplayString(file.name), 1),
                            _createElementVNode("p", _hoisted_50, "Size: " + _toDisplayString(_ctx.formatFileSize(file.metadata?.size)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.getFileUrl(file.name)),
                              class: "px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600"
                            }, " View ", 8, _hoisted_52),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.confirmDelete(file.name)),
                              class: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600"
                            }, " Delete ", 8, _hoisted_53)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("p", null, "No files found in the " + _toDisplayString(_ctx.listBucket) + " bucket.", 1)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}